
import React from 'react';
import Layout from '@/components/Layout/Layout';
import TaxCalculator from '@/components/SpecialCalculators/FinancialCalculators/TaxCalculator';
import { Link } from 'react-router-dom';

const TaxCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4">
        {/* Header Section */}
        <div className="mb-8">
          <div className="text-sm text-gray-500 mb-2">
            <Link to="/" className="hover:underline">Home</Link> {' > '} 
            <Link to="/special" className="hover:underline">Special Tools</Link> {' > '} 
            <span>Tax Calculator</span>
          </div>
          <h1 className="text-3xl font-bold mb-3">Tax Calculator</h1>
          <p className="text-gray-700">
            Estimate your income taxes, understand your effective tax rate, and calculate your take-home pay.
          </p>
        </div>

        {/* Calculator Section */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-8">
          <TaxCalculator />
        </div>

        {/* Information Section */}
        <div className="bg-[#E6F3FF] p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-semibold mb-3">How to use the Tax Calculator</h2>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-2">
            <li>Enter your annual income</li>
            <li>Select your filing status (single, married filing jointly, or head of household)</li>
            <li>Choose your state of residence (for state income tax calculation)</li>
            <li>The calculator will show your estimated federal tax, FICA taxes, state tax, and take-home pay</li>
          </ol>
        </div>

        {/* Additional Information */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">About Income Tax Calculations</h2>
          <p className="text-gray-700 mb-3">
            The U.S. income tax system is progressive, meaning that different portions of your income are taxed at different 
            rates. As your income increases, the additional income is taxed at higher rates according to tax brackets.
          </p>
          <p className="text-gray-700 mb-3">
            FICA taxes include Social Security tax (6.2% on income up to the wage base limit) and Medicare tax (1.45% on all 
            earned income). High earners pay an additional 0.9% Medicare tax on income above certain thresholds.
          </p>
          <p className="text-gray-700 mb-3">
            Your effective tax rate is the average rate at which your income is taxed, which is typically lower than your 
            highest marginal tax rate. This calculator provides a simplified estimate and doesn't account for deductions, 
            credits, or other adjustments that might lower your actual tax liability.
          </p>
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
            <p className="text-sm text-yellow-700">
              <strong>Disclaimer:</strong> This calculator provides estimates based on simplified tax calculations and should not 
              be used for tax preparation or filing purposes. For accurate tax advice, please consult a tax professional.
            </p>
          </div>
        </div>

        {/* Related Calculators */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">Related Calculators</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Link to="/special/salary" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💼</span> Salary Calculator
            </Link>
            <Link to="/special/retirement" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">👴</span> Retirement Calculator
            </Link>
            <Link to="/special/mortgage" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">🏠</span> Mortgage Calculator
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TaxCalculatorPage;
